import React from 'react';
import { createSvgIcon } from '../../utils/createSvgIcon';

export const SortIcon = createSvgIcon(
  <svg width="14" height="13" viewBox="0 0 14 13" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M0.821962 8.67676L2.36614 10.2209L2.36614 0H3.52855L3.52855 10.2209L5.07272 8.67676L5.8657 9.52768L3.35831 12.0351C3.13134 12.262 2.76334 12.262 2.53637 12.0351L1.52588e-05 9.49871L0.821962 8.67676Z"
      fill="currentColor"
    />
    <path
      d="M8.95625 3.52832L10.5004 1.98414L10.5004 12.2051H11.6628L11.6628 1.98414L13.207 3.52832L14 2.6774L11.4926 0.170017C11.2656 -0.0569572 10.8976 -0.0569572 10.6707 0.170017L8.13431 2.70637L8.95625 3.52832Z"
      fill="currentColor"
    />
  </svg>,
  'sort'
);
